export default {
  telephones: [],
  telephoneFolders: [],
  infoDB: {}
}
